<template>
  <div>
    <el-row type="flex" justify="center" align="middle" :gutter="5">
      <el-col :span="11"
        ><div v-if="title1" class="grid-title">{{ title1 }}</div></el-col
      >
      <el-col :span="2" />
      <el-col :span="11"
        ><div v-if="title2" class="grid-title">{{ title2 }}</div></el-col
      >
    </el-row>
    <el-row type="flex" justify="center" align="middle" :gutter="5">
      <el-col :span="11">
        <div style="height: 350px">
          <GridVx
            ref="agGrid1"
            dom-layout="scrool"
            :disabled-sortable="null"
            :columns="columns1"
            :rows="rowData1"
            :auto-select-first-row="false"
            :row-multi-select-with-click="true"
            class="agGrid"
            :auto-size-cell="true"
            @selectionChanged="onSelectRowData1"
          />
        </div>
      </el-col>
      <el-col :span="2">
        <el-row type="flex" justify="center">
          <button
            class="btn only-icon"
            style="margin-bottom: 10px"
            :disabled="disableTransButton1"
            @click="transDataToSecondTable"
          >
            <i class="el-icon-d-arrow-right"></i>
          </button>
        </el-row>
        <el-row type="flex" justify="center">
          <button
            class="btn only-icon"
            style="margin-bottom: 10px"
            :disabled="disableTransButton2"
            @click="transDataToFirstTable"
          >
            <i class="el-icon-d-arrow-left"></i>
          </button>
        </el-row>
      </el-col>
      <el-col :span="11">
        <div style="height: 350px">
          <GridVx
            ref="agGrid2"
            dom-layout="scrool"
            :disabled-sortable="null"
            :columns="columns2"
            :rows="rowData2"
            :auto-select-first-row="false"
            :row-multi-select-with-click="true"
            class="agGrid"
            :auto-size-cell="true"
            @selectionChanged="onSelectRowData2"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    title1: String,
    title2: String,
    columns1: {
      type: Array,
      default: () => []
    },
    rows1: {
      type: Array,
      default: () => []
    },
    columns2: {
      type: Array,
      default: () => []
    },
    rows2: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rowData1: null,
      rowData2: null,
      disableTransButton1: true,
      disableTransButton2: true
    }
  },
  watch: {
    rows1: {
      immediate: true,
      handler(val) {
        this.rowData1 = val
      }
    },
    rows2: {
      immediate: true,
      handler(val) {
        this.rowData2 = val
      }
    }
  },
  mounted() {
    this.gridApi1 = this.$refs.agGrid1.gridApi
    this.gridColumnApi1 = this.$refs.agGrid1.columnApi
    this.gridApi2 = this.$refs.agGrid2.gridApi
    this.gridColumnApi2 = this.$refs.agGrid2.columnApi
  },
  methods: {
    onSelectRowData1(rows) {
      this.disableTransButton1 = !rows?.length
    },

    onSelectRowData2(rows) {
      this.disableTransButton2 = !rows?.length
    },

    transDataToSecondTable() {
      const rowsSelected = this.gridApi1.getSelectedRows()
      // this.rows1 = this.rows1.filter((row) => !rowsSelected.includes(row))
      this.gridApi1.applyTransaction({
        remove: rowsSelected
      })
      this.gridApi2.applyTransaction({
        add: rowsSelected
      })

      // this.rows2.push(...rowsSelected)

      const rows1 = this.rows1?.filter(row => !rowsSelected.includes(row))
      const rows2 = [...this.rows2, ...rowsSelected]

      this.$emit('transferData', rows1, rows2)
    },
    transDataToFirstTable() {
      const rowsSelected = this.gridApi2.getSelectedRows()
      // this.rows2 = this.rows2.filter((row) => !rowsSelected.includes(row))
      this.gridApi2.applyTransaction({
        remove: rowsSelected
      })
      this.gridApi1.applyTransaction({
        add: rowsSelected
      })

      const rows2 = this.rows2?.filter(row => !rowsSelected.includes(row))
      const rows1 = [...this.rows1, ...rowsSelected]

      this.$emit('transferData', rows1, rows2)
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-title {
  font-weight: 700;
  color: #357456;
  text-transform: uppercase;
  margin: 10px 0;
}

.btn {
  background: #357456;
  border-radius: 5px;
  &.only-icon {
    i {
      color: #fff;
    }
  }
}
</style>
